
import Breadcrumbs from '~/components/UI/Breadcrumbs.vue';
import { CmsMixin } from '~/node_modules/sitis-nuxt/lib/mixins';

// CMS-разделы, у которых нет хлебных крошек из CMS-лейаута (MainLayout):
// строим цепочку из пунктов меню + заголовка текущей страницы.
const SECTION_PREFIXES = ['vidy-perevozok', 'napravlenie', 'napravlenia', 'ural', 'gruzoperevozki'];

// Родитель-замена для разделов без прямого пункта в меню (например, /ural/*)
const PARENT_ALIASES = {
  ural: 'napravlenie/ural',
};

export default {
  name: 'MenuCmsPage',

  mixins: [CmsMixin],

  components: { Breadcrumbs },

  fetch: async function () {
    if (!this.needBreadcrumbs) {
      return;
    }

    try {
      this.cmsPage = await this.getPage({ pageIdOrName: this.path, contentOnly: false });
    } catch (e) {
      this.cmsPage = null;
    }
  },

  data: function () {
    return {
      cmsPage: null,
    };
  },

  head: function () {
    const crumbs = this.cmsBreadcrumbs || [];

    if (crumbs.length < 2) {
      return {};
    }

    const itemListElement = crumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: String(crumb.title || '').trim(),
      item: crumb.path || '/',
    }));

    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement,
          }),
        },
      ],
    };
  },

  computed: {
    path() {
      return this.$route.path === '/' ? 'homepage' : this.$route.path;
    },

    needBreadcrumbs() {
      const path = this.$route.path || '/';

      return SECTION_PREFIXES.some((prefix) => path.trim() === `/${prefix}` || path.startsWith(`/${prefix}/`));
    },

    // Все пункты меню: path -> title (из всех меню CMS, дерева и flatMenu)
    menuItems() {
      const items = new Map();

      const collect = (list) => {
        if (!Array.isArray(list)) {
          return;
        }

        list.forEach((item) => {
          if (!item || !item.path || Number(item.isHidden)) {
            return;
          }

          const rawPath = String(item.path).replace(/^\/+/, '').replace(/\/+$/, '');
          const title = String(item.title || '').trim();

          if (rawPath && title && !items.has(rawPath)) {
            items.set(rawPath, title);
          }

          if (item.children) {
            collect(item.children);
          }
        });
      };

      const cms = this.$store.state.cms || {};
      const menus = cms.menus || {};

      Object.keys(menus).forEach((menuName) => {
        const menu = menus[menuName];
        if (menu && menu.items) {
          collect(menu.items);
        }
      });

      collect(cms.menu);
      collect(cms.flatMenu);

      return items;
    },

    cmsPageTitle() {
      const page = this.cmsPage;

      if (!page) {
        return '';
      }

      const inner = page.page || page;

      return String(inner.title || inner.titleTag || '').trim();
    },

    cmsBreadcrumbs() {
      if (!this.needBreadcrumbs) {
        return [];
      }

      const path = this.$route.path;
      const norm = String(path).replace(/^\/+|\/+$/g, '');
      const currentPath = `/${norm}`;
      const items = this.menuItems || new Map();
      const crumbs = [{ title: 'Главная', path: '/' }];

      const exists = (crumbPath) => crumbs.some((crumb) => crumb.path === crumbPath);

      // Предки по префиксам пути
      Array.from(items.keys())
        .filter((itemPath) => currentPath.startsWith(`/${itemPath}/`))
        .sort((a, b) => a.split('/').length - b.split('/').length)
        .forEach((itemPath) => {
          const crumbPath = `/${itemPath}`;
          if (!exists(crumbPath)) {
            crumbs.push({ title: items.get(itemPath), path: crumbPath });
          }
        });

      // Родитель-замена для разделов без прямого пункта меню
      if (crumbs.length === 1) {
        const section = norm.split('/')[0];
        const parentAlias = PARENT_ALIASES[section];
        if (parentAlias && items.has(parentAlias)) {
          const crumbPath = `/${parentAlias}`;
          if (!exists(crumbPath)) {
            crumbs.push({ title: items.get(parentAlias), path: crumbPath });
          }
        }
      }

      const title = this.cmsPageTitle || (items.has(norm) ? items.get(norm) : '');

      if (title) {
        crumbs.push({ title, path });
      }

      return crumbs;
    },
  },
};
